import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';

import { setLanguage } from '_locales';

import { TChatOptions } from '_types/options';

import { loadFont } from '_utils/font';
import { initHttpAPI } from '_utils/http';
import { getChatOptions } from '_utils/script';

import App from './App';

const HOST_ID = 'ada-chat';

const mount = (options: TChatOptions) => {
  if (document.getElementById(HOST_ID)) return;

  initHttpAPI(options.apiKey, options.apiUrl);
  setLanguage(options.lang);
  loadFont();

  const host = document.createElement('div');
  const shadow = host.attachShadow({ mode: 'open' });
  const container = document.createElement('div');

  host.id = HOST_ID;
  shadow.appendChild(container);
  document.body.appendChild(host);

  createRoot(container).render(
    <StyleSheetManager target={shadow}>
      <App options={options} />
    </StyleSheetManager>,
  );
};

const options = getChatOptions();

if (!options) {
  console.warn(
    '[Ada] The script tag needs data-api-key and data-api-url: the chat is not mounted.',
  );
} else if (document.body) {
  mount(options);
} else {
  document.addEventListener('DOMContentLoaded', () => mount(options));
}
